'use client';

import { createContext } from 'react';

import type { PaletteMode, PaletteOptions } from '@mui/material';

export interface ColorMode {
  toggleColorMode: () => void;
  setMode: React.Dispatch<React.SetStateAction<PaletteMode>>;
  togglePreferenceMode: () => void;
  setIsInPreferenceMode: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface ColorModeContextState {
  mode: PaletteMode;
  colorMode: ColorMode;
  darkPalette: PaletteOptions | null;
}

const initialColorMode: ColorModeContextState = {
  mode: 'light',
  colorMode: {
    toggleColorMode: () => void 0,
    setMode: () => void 0,
    togglePreferenceMode: () => void 0,
    setIsInPreferenceMode: () => void 0,
  },
  darkPalette: null,
};

export const ColorModeContext = createContext( initialColorMode );
